<footer class="text-center p-3">
  <div>
    <app-language-selector />
  </div>

  <div class="mt-3 flex-content-center">
    <a
      href="https://www.stageflux.com"
      target="_blank"
      class="text-gray-600 hover:underline"
    >
      Powered by StageFlux
    </a>
  </div>
</footer>
